var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1557_4873",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 6,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6,
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1557_4873)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.1667 21.8334H11.218L19.7484 13.303L18.6972 12.2517L10.1667 20.7822V21.8334ZM8.91675 23.0834V20.263L19.9088 9.27571C20.0348 9.16126 20.1739 9.07286 20.3261 9.0105C20.4785 8.948 20.6382 8.91675 20.8053 8.91675C20.9724 8.91675 21.1342 8.9464 21.2907 9.00571C21.4474 9.06501 21.5861 9.15932 21.7067 9.28862L22.7245 10.319C22.8538 10.4397 22.9459 10.5786 23.0009 10.7357C23.0559 10.8928 23.0834 11.0499 23.0834 11.207C23.0834 11.3746 23.0548 11.5345 22.9976 11.6867C22.9404 11.8391 22.8493 11.9783 22.7245 12.1042L11.7372 23.0834H8.91675ZM19.2136 12.7865L18.6972 12.2517L19.7484 13.303L19.2136 12.7865Z",
    fill: "black",
    fillOpacity: 0.6
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconButton);
export default __webpack_public_path__ + "static/media/Icon_Button.2ab8fa2b38ce795476cf710df7bc93f9.svg";
export { ForwardRef as ReactComponent };